import type { Dayjs } from 'dayjs';
import type { CompositionEditorRow } from './compositionEditorAdapter';
import type {
  ClosingPackageCompositionResult,
  ClosingPackageProjection,
} from '../types';
import {
  buildFormationConfirmBody,
  validateFormationComposition,
} from './formationModalValidation';
import { validateTaskModalEventDate } from './taskModalValidation';
import { CLOSING_PACKAGE_TASK_TYPE } from '../workspace/closingPackageTaskTypes';

export type RevisionValidationCode =
  | 'EVENT_DATE_REQUIRED'
  | 'REVISION_STATE_INVALID'
  | 'RECOMMENDED_MODE'
  | 'COMPOSITION_EMPTY'
  | 'REQUIRED_DOCUMENT_MISSING'
  | 'REQUIRED_DOCUMENT_BLOCKED';

export type RevisionValidationIssue = {
  code: RevisionValidationCode;
  message: string;
  itemLabel?: string;
};

export type ValidateRevisionFormInput = {
  eventAt: Dayjs | null | undefined;
  comment: string | null | undefined;
};

export type ValidateRevisionCompositionInput = {
  projection: ClosingPackageProjection;
  composition: ClosingPackageCompositionResult | null | undefined;
  rows: CompositionEditorRow[];
};

export const REVISION_SUCCESS_NEXT_TASK = CLOSING_PACKAGE_TASK_TYPE.SEND_SCANS_TO_CLIENT;

export function validateRevisionFormFields(
  input: ValidateRevisionFormInput
): RevisionValidationIssue | null {
  return validateTaskModalEventDate(
    input.eventAt,
    'Укажите дату выполнения доработки'
  ) as RevisionValidationIssue | null;
}

export function validateRevisionComposition(
  input: ValidateRevisionCompositionInput
): RevisionValidationIssue | null {
  if (input.projection.workflowState !== 'REVISION_REQUIRED') {
    return {
      code: 'REVISION_STATE_INVALID',
      message: 'Доработка доступна только в состоянии «Требуется доработка»',
    };
  }

  return validateFormationComposition(input, 'revision') as RevisionValidationIssue | null;
}

export function validateRevisionSubmit(input: {
  form: ValidateRevisionFormInput;
  composition: ValidateRevisionCompositionInput;
}): RevisionValidationIssue | null {
  return validateRevisionFormFields(input.form) ?? validateRevisionComposition(input.composition);
}

export function buildRevisionConfirmBody(
  comment: string,
  revisedAt?: string | null
): ReturnType<typeof buildFormationConfirmBody> {
  return buildFormationConfirmBody(comment, revisedAt);
}

export function getRevisionSuccessMessage(): string {
  return 'Доработка комплекта зарегистрирована';
}
